import { buttonVariants } from '@repo/shared-client/components/ui'
import { cn } from '@repo/shared-client/lib/utils'
import { Link } from '@tanstack/react-router'
import { useTranslation } from '@web/src/lib/intl/react'
import { type VariantProps } from 'class-variance-authority'
import { type ComponentPropsWithoutRef, forwardRef } from 'react'
import LogoSymbol from '../logo-symbol/logo-symbol'

const logoImgClass = 'h-6 w-auto select-none object-contain [filter:drop-shadow(1px_2px_1px_#000000)]'

export interface SFJoinButtonProps
  extends Omit<ComponentPropsWithoutRef<typeof Link>, 'to' | 'children'>,
    VariantProps<typeof buttonVariants> {}

const SFJoinButton = forwardRef<HTMLAnchorElement, SFJoinButtonProps>((props, forwardedRef) => {
  const { t } = useTranslation()
  const { className, size = 'default', variant = 'default', ...rest } = props

  return (
    <Link
      className={cn(
        buttonVariants({ size, variant }),
        'h-10 cursor-pointer touch-manipulation no-underline hover:no-underline',
        className
      )}
      draggable={false}
      onContextMenu={(e) => {
        e.preventDefault()
      }}
      ref={forwardedRef}
      to="/auth/signup"
      {...rest}
    >
      <span className="inline-flex items-center gap-2 text-base">
        <LogoSymbol imageClassName={logoImgClass} />
        <span>{t('Join For Free')}</span>
        <LogoSymbol imageClassName={logoImgClass} />
      </span>
    </Link>
  )
})

SFJoinButton.displayName = 'SFJoinButton'

export default SFJoinButton
